import { useOpenDialog } from '@/domain/hooks/useDialog'
import { useUnifiedPortfolio } from '@/features/portfolio'
import { withSuspense } from '@/ui/utils/withSuspense'

import { MyPortfolioSkeleton } from './components/skeleton/MyPortfolioSkeleton'
import { GuestView } from '@/ui/organisms/guest-view/GuestView'
import { PositionView } from './views/PositionView'
import { usePrivy } from '@privy-io/react-auth'
import { useAccount } from 'wagmi'

function MyPortfolioContainer() {
  const { address } = useAccount()
  const portfolio = useUnifiedPortfolio()
  const { deposits, borrows } = portfolio.positionData.isolated
  const { connectWallet } = usePrivy()
  const openDialog = useOpenDialog()
  const hasData = deposits.length > 0 || borrows.length > 0
  const isLoading = (portfolio.loading.isolatedPairs || portfolio.loading.isolatedPositions) && !hasData

  if (!address) {
    return <GuestView openConnectModal={connectWallet} />
  }

  if (isLoading) {
    return <MyPortfolioSkeleton />
  }

  return <PositionView deposits={deposits} borrows={borrows} openDialog={openDialog} />
}

const MyPortfolioContainerWithSuspense = withSuspense(MyPortfolioContainer, MyPortfolioSkeleton)
export { MyPortfolioContainerWithSuspense as MyPortfolioContainer }
